import * as React from 'react';
import { AdminDashboardPageLayout } from '../../containers/AdminDashboardPageLayout';
import { BlogImportHistory } from '../../containers/blogs/BlogImportHistory';

export const AdminAccountBlogImportHistoryPage: React.FC = () => {
	return (
		<AdminDashboardPageLayout>
			<BlogImportHistory />
		</AdminDashboardPageLayout>
	);
};
